import {
  FOLDER_ALREADY_EXISTS_MESSAGE,
  MODULE_ALREADY_EXISTS_MESSAGE,
} from '../api/directories.api';
import type { DirectoryNodeKind } from '../model/types';

export interface DirectoryNodeCopy {
  sectionTitle: string;
  titleLabel: string;
  titlePlaceholder: string;
  duplicateTitleMessage?: string;
  showTitleField: boolean;
  showIconField: boolean;
  showArchiveField: boolean;
  showSaveButton: boolean;
  showAddMenu: boolean;
}

const FILE_COPY: DirectoryNodeCopy = {
  sectionTitle: 'Arquivo',
  titleLabel: 'Nome do arquivo',
  titlePlaceholder: 'Escreva um nome para o arquivo',
  showTitleField: false,
  showIconField: false,
  showArchiveField: false,
  showSaveButton: false,
  showAddMenu: false,
};

export const DIRECTORY_NODE_COPY: Record<DirectoryNodeKind, DirectoryNodeCopy> = {
  module: {
    sectionTitle: 'Módulo',
    titleLabel: 'Título do Módulo',
    titlePlaceholder: 'Escreva um título que represente o Módulo',
    duplicateTitleMessage: MODULE_ALREADY_EXISTS_MESSAGE,
    showTitleField: true,
    showIconField: true,
    showArchiveField: false,
    showSaveButton: true,
    showAddMenu: true,
  },
  folder: {
    ...FILE_COPY,
    sectionTitle: 'Pasta',
    titleLabel: 'Título da Pasta',
    titlePlaceholder: 'Escreva um título que represente a pasta',
    duplicateTitleMessage: FOLDER_ALREADY_EXISTS_MESSAGE,
    showTitleField: true,
    showSaveButton: true,
    showAddMenu: true,
  },
  document: {
    ...FILE_COPY,
    sectionTitle: 'Documento',
  },
  record: {
    ...FILE_COPY,
    sectionTitle: 'Registro',
    showSaveButton: true,
  },
  matrix: {
    ...FILE_COPY,
    sectionTitle: 'Registro',
    showArchiveField: true,
    showSaveButton: true,
  },
  generatedRecord: {
    ...FILE_COPY,
    sectionTitle: 'Registro gerado',
  },
  file: FILE_COPY,
};
